import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';

const url = process.env.REACT_APP_BACKEND_URL;

export const getAllAccess = async (setData) => {
  try {
    await axios.get(`${url}/access_groups`)
    .then((res) => setData(res.data))
    .catch((error)=>console.log(error))
  }
  catch (error) {
    console.log(error);
    console.clear()
  }
};

export const PostAccess = async (setIsLoading,data,  setPostData,setSelectedDisplayItem,setErrMessage,setErrorType,handleClick) => {
  setIsLoading(true)
  try {
    await axios.post(`${url}/group/update_user`, {
      group_id:data.group_id,
      accesses:[{menu_id:data.menu_id,item_id:data.item_id}]
    },{
      headers:{
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res) => {
    setErrMessage(res.data?res.data.message:"Access provided successfully")
    setIsLoading(false)
    setErrorType("success")
    setPostData({
      group_id: "",
      menu_id: "",
      item_id: []
    });
    setSelectedDisplayItem([])
    setTimeout(()=>{
      window.location.reload();
    },1500)
    handleClick()
      });
   
  } catch (error) {
    TokenLogout(error)
    setErrMessage(error.response?error.response.data.error:"Something went wrong")
    setErrorType("error")
    handleClick()
    setIsLoading(false)
  }
};

export const PostDeleteAccess = async (data,setErrMessage,setErrorType,handleClick,handleAlertDialogClose,handleDialogClose,GetGroup,setGetData) => {
  try {
    await axios.post(`${url}/group/update_user`, {
      group_id:data.group_id,
      remove_accesses:[{menu_id:data.menu_id,item_id:data.item_id}]
    },{
      headers:{
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      }
    })
    .then((res) => console.log(res.data));

    setErrMessage("Access removed successfully")
    setErrorType("success")
    handleClick()
    handleAlertDialogClose()
    setTimeout(()=>{
      GetGroup(setGetData)
      handleDialogClose()
    },2000)
  } catch (error) {
    // console.log(error);
    TokenLogout(error)
    setErrMessage("Something went wrong")
    setErrorType("error")
    handleClick()

  }
};

export const DeleteAccess = (id, setGetData) => {
  try {
    axios.delete(`${url}/access_groups/${id}`)
    .then((res) =>{
         console.log(res.data)
        })
    getAllAccess(setGetData);
    window.location.reload();
  }
  catch (error) {
    console.log(error);
  }
};

export const getAccessById = (id, setData) => {
  try {
    axios.get(`${url}/group/${id}`,{
      headers:{
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      }
      }).then((res) => setData(res.data))
  } catch (error) {
    // console.log(error);
    TokenLogout(error)
  }
};

export const EditAccess = (data) => {
  try {
    axios.put(`${url}/access_groups/${data._id}`, data).then((res) => console.log(res.data));
    //   window.location.reload()
  } catch (error) {
    // console.log(error);
    TokenLogout(error)
  }
};

export const getAccessByToken=(setData,setAccessErr)=>{
  try{
    axios.get(`${url}/group/get_accesses`,{
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      }
    })
   .then(res=>setData(res.data))
   .catch((err)=>{
     console.log(err);
     TokenLogout(err)
     setAccessErr(true)
    setTimeout(()=>{
      sessionStorage.clear();
      window.location.href="/";
    },2000)

   })

  }
  catch(error){
    setAccessErr(true)
    TokenLogout(error)
    setTimeout(()=>{
      sessionStorage.clear();
      window.location.href="/";
    },2000)
  }
}
